import { FC } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import styled from 'styled-components'
import { TPreReservationFormValues } from '@app.feature/exam/gsat2024-2/constants/form'
import useGetPredictionSelectOptions from '@app.feature/exam/gsat2024-2/hooks/useGetExamTestSelectOptions'
import PredictionInputSelect from '../input/PredictionInputSelect.mobile'
import PredictionFormLabel from '../label/PredictionFormLabel.mobile'

interface IFProps {
  companyId: string
  termId: string
}

const FormItemDepartment: FC<IFProps> = ({ companyId, termId }) => {
  const { departments } = useGetPredictionSelectOptions({
    companyId,
    termId,
  })

  const departmentId = useWatch<TPreReservationFormValues, 'departmentId'>({
    name: 'departmentId',
  })

  const {
    setValue,
    formState: { errors },
  } = useFormContext<TPreReservationFormValues>()

  const handleOnChangeDepartments = (value: string) => {
    setValue('departmentId', value, {
      shouldValidate: true,
      shouldDirty: true,
    })
    setValue('jobId', '', {
      shouldValidate: true,
      shouldDirty: true,
    })
  }

  const defaultOption = departments?.find(
    (departments) => departments?.value === departmentId,
  )

  return (
    <StyledWrapper>
      <PredictionFormLabel label="사업부" />
      <PredictionInputSelect
        placeholder="사업부 선택"
        isErrors={!!errors.departmentId?.message}
        defaultSelectOption={defaultOption}
        options={departments}
        onChangeSelect={handleOnChangeDepartments}
      />
    </StyledWrapper>
  )
}

export default FormItemDepartment

const StyledWrapper = styled.div`
  width: 100%;
  height: 45px;
  display: flex;
  align-items: center;
  margin-right: 66px;

  > p {
    flex: 3;
  }

  > div {
    flex: 7;
  }
`
